import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileFiltersButton',
  props: {
    sticky: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var stickyAnchorRef = ref(null);
    var isSticky = ref(false);
    var observer;
    function initObserver() {
      return new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            isSticky.value = true;
          } else {
            isSticky.value = false;
          }
        });
      }, {
        root: null,
        threshold: 0
      });
    }
    onMounted(function () {
      if (stickyAnchorRef.value && isMobile.value) {
        observer = initObserver();
        observer.observe(stickyAnchorRef.value);
      }
    });
    onUnmounted(function () {
      if (observer) {
        observer.disconnect();
      }
    });
    return {
      __sfc: true,
      translate: translate,
      isMobile: isMobile,
      stickyAnchorRef: stickyAnchorRef,
      isSticky: isSticky,
      observer: observer,
      initObserver: initObserver,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});